import { combinedApi as api } from '@redux/combinedApi';
export const addTagTypes = ['ImportBucket'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getImportBucketGetImportBucket: build.mutation<
        GetImportBucketGetImportBucketApiResponse,
        GetImportBucketGetImportBucketApiArg
      >({
        query: (queryArg) => ({
          url: `/ImportBucket/get-import-bucket`,
          method: 'GET',
          params: {
            fileName: queryArg,
          },
        }),
        invalidatesTags: ['ImportBucket'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as importBucketApi };
export type GetImportBucketGetImportBucketApiResponse = unknown;
export type GetImportBucketGetImportBucketApiArg =
  /** The name of the file to upload (e.g., "testDevice_c2h_3gdfg4gf.csv") */ string | undefined;
export const { useGetImportBucketGetImportBucketMutation } = injectedRtkApi;
